import {
  getStorage,
  connectStorageEmulator,
  ref,
  getDownloadURL,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { app } from "./app";

export { ref, getDownloadURL, uploadBytes, uploadBytesResumable };
export const storage = getStorage(
  app,
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
);

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  connectStorageEmulator(
    storage,
    import.meta.env.VITE_FIREBASE_EMULATOR_HOST,
    // Default so a mode that sets VITE_USE_FIREBASE_EMULATOR without the
    // port vars connects to the standard port instead of NaN, which fails
    // silently.
    parseInt(import.meta.env.VITE_FIREBASE_EMULATOR_STORAGE_PORT, 10) || 9199,
  );
}
